import { useEffect } from "react";

export interface KeyboardNavHandlers {
  onNext: () => void;
  onPrev: () => void;
  onTogglePresent: () => void;
  onEscape: () => void;
  isPresent: boolean;
  isOverviewOpen: boolean;
}

export function useKeyboardNav(handlers: KeyboardNavHandlers) {
  const { onNext, onPrev, onTogglePresent, onEscape, isPresent, isOverviewOpen } = handlers;

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      const target = e.target as HTMLElement | null;
      if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable)) {
        return;
      }

      if (isOverviewOpen) {
        if (e.key === "Escape") {
          onEscape();
          e.preventDefault();
        }
        return;
      }

      if (e.key === "ArrowRight" || (isPresent && e.key === " ")) {
        onNext();
        e.preventDefault();
      } else if (e.key === "ArrowLeft") {
        onPrev();
        e.preventDefault();
      } else if (e.key === "Escape") {
        onEscape();
      } else if (e.key.toLowerCase() === "p") {
        onTogglePresent();
        e.preventDefault();
      }
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onNext, onPrev, onTogglePresent, onEscape, isPresent, isOverviewOpen]);
}

